///proformainvoice/list
export const PROFORMA_INVOICE_LIST = "PROFORMA_INVOICE_LIST";
export const PROFORMA_INVOICE_LIST_SUCCESS = "PROFORMA_INVOICE_LIST_SUCCESS";
export const PROFORMA_INVOICE_LIST_FAILURE = "PROFORMA_INVOICE_LIST_FAILURE";
// /proformainvoice/list - Search (Spesific customer)
export const PROFORMA_INVOICE_LIST_SEARCH = "PROFORMA_INVOICE_LIST_SEARCH";
export const PROFORMA_INVOICE_LIST_SEARCH_SUCCESS =
  "PROFORMA_INVOICE_LIST_SEARCH_SUCCESS";
export const PROFORMA_INVOICE_LIST_SEARCH_FAILURE =
  "PROFORMA_INVOICE_LIST_SEARCH_FAILURE";
///proformainvoice/data
export const PROFORMA_INVOICE_DATA = "PROFORMA_INVOICE_DATA";
export const PROFORMA_INVOICE_DATA_SUCCESS = "PROFORMA_INVOICE_DATA_SUCCESS";
export const PROFORMA_INVOICE_DATA_FAILURE = "PROFORMA_INVOICE_DATA_FAILURE";
///proformainvoice/create
export const PROFORMA_INVOICE_CREATE = "PROFORMA_INVOICE_CREATE";
export const PROFORMA_INVOICE_CREATE_SUCCESS =
  "PROFORMA_INVOICE_CREATE_SUCCESS";
export const PROFORMA_INVOICE_CREATE_FAILURE =
  "PROFORMA_INVOICE_CREATE_FAILURE";
///proformainvoice/update
export const PROFORMA_INVOICE_UPDATE = "PROFORMA_INVOICE_UPDATE";
export const PROFORMA_INVOICE_UPDATE_SUCCESS =
  "PROFORMA_INVOICE_UPDATE_SUCCESS";
export const PROFORMA_INVOICE_UPDATE_FAILURE =
  "PROFORMA_INVOICE_UPDATE_FAILURE";
///proformainvoice/void
export const PROFORMA_INVOICE_VOID = "PROFORMA_INVOICE_VOID";
export const PROFORMA_INVOICE_VOID_SUCCESS = "PROFORMA_INVOICE_VOID_SUCCESS";
export const PROFORMA_INVOICE_VOID_FAILURE = "PROFORMA_INVOICE_VOID_FAILURE";
///proformainvoiceitem/search
export const PROFORMA_INVOICE_ITEM_SEARCH = "PROFORMA_INVOICE_ITEM_SEARCH";
export const PROFORMA_INVOICE_ITEM_SEARCH_SUCCESS =
  "PROFORMA_INVOICE_ITEM_SEARCH_SUCCESS";
export const PROFORMA_INVOICE_ITEM_SEARCH_FAILURE =
  "PROFORMA_INVOICE_ITEM_SEARCH_FAILURE";
///proformainvoiceitem/list
export const PROFORMA_INVOICE_ITEM_LIST = "PROFORMA_INVOICE_ITEM_LIST";
export const PROFORMA_INVOICE_ITEM_LIST_SUCCESS =
  "PROFORMA_INVOICE_ITEM_LIST_SUCCESS";
export const PROFORMA_INVOICE_ITEM_LIST_FAILURE =
  "PROFORMA_INVOICE_ITEM_LIST_FAILURE";
///proformainvoicestatus/list
export const PROFORMA_INVOICE_STATUS_LIST = "PROFORMA_INVOICE_STATUS_LIST";
export const PROFORMA_INVOICE_STATUS_LIST_SUCCESS =
  "PROFORMA_INVOICE_STATUS_LIST_SUCCESS";
export const PROFORMA_INVOICE_STATUS_LIST_FAILURE =
  "PROFORMA_INVOICE_STATUS_LIST_FAILURE";
///proformainvoicestatus/data
export const PROFORMA_INVOICE_STATUS_DATA = "PROFORMA_INVOICE_STATUS_DATA";
export const PROFORMA_INVOICE_STATUS_DATA_SUCCESS =
  "PROFORMA_INVOICE_STATUS_DATA_SUCCESS";
export const PROFORMA_INVOICE_STATUS_DATA_FAILURE =
  "PROFORMA_INVOICE_STATUS_DATA_FAILURE";
///proformainvoicestatus/create
export const PROFORMA_INVOICE_STATUS_CREATE = "PROFORMA_INVOICE_STATUS_CREATE";
export const PROFORMA_INVOICE_STATUS_CREATE_SUCCESS =
  "PROFORMA_INVOICE_STATUS_CREATE_SUCCESS";
export const PROFORMA_INVOICE_STATUS_CREATE_FAILURE =
  "PROFORMA_INVOICE_STATUS_CREATE_FAILURE";
///proformainvoicestatus/update
export const PROFORMA_INVOICE_STATUS_UPDATE = "PROFORMA_INVOICE_STATUS_UPDATE";
export const PROFORMA_INVOICE_STATUS_UPDATE_SUCCESS =
  "PROFORMA_INVOICE_STATUS_UPDATE_SUCCESS";
export const PROFORMA_INVOICE_STATUS_UPDATE_FAILURE =
  "PROFORMA_INVOICE_STATUS_UPDATE_FAILURE";
///proformainvoicestatus/delete
export const PROFORMA_INVOICE_STATUS_DELETE = "PROFORMA_INVOICE_STATUS_DELETE";
export const PROFORMA_INVOICE_STATUS_DELETE_SUCCESS =
  "PROFORMA_INVOICE_STATUS_DELETE_SUCCESS";
export const PROFORMA_INVOICE_STATUS_DELETE_FAILURE =
  "PROFORMA_INVOICE_STATUS_DELETE_FAILURE";
///proformainvoice/pdf
export const PROFORMA_INVOICE_PDF = "PROFORMA_INVOICE_PDF";
export const PROFORMA_INVOICE_PDF_SUCCESS = "PROFORMA_INVOICE_PDF_SUCCESS";
export const PROFORMA_INVOICE_PDF_FAILURE = "PROFORMA_INVOICE_PDF_FAILURE";
////proformainvoice/emailsend/automated/
export const PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED =
  "PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED";
export const PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_SUCCESS =
  "PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_SUCCESS";
export const PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_FAILURE =
  "PROFORMA_INVOICE_EMAIL_SEND_AUTOMATED_FAILURE";
///proformainvoice/emailresend/automated/
export const PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED =
  "PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED";
export const PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_SUCCESS =
  "PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_SUCCESS";
export const PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_FAILURE =
  "PROFORMA_INVOICE_EMAIL_RESEND_AUTOMATED_FAILURE";
///proformainvoice/converttoinvoice
export const PROFORMA_INVOICE_CONVERT_TO_INVOICE =
  "PROFORMA_INVOICE_CONVERT_TO_INVOICE";
export const PROFORMA_INVOICE_CONVERT_TO_INVOICE_SUCCESS =
  "PROFORMA_INVOICE_CONVERT_TO_INVOICE_SUCCESS";
export const PROFORMA_INVOICE_CONVERT_TO_INVOICE_FAILURE =
  "PROFORMA_INVOICE_CONVERT_TO_INVOICE_FAILURE";
///proformainvoice/search
export const PROFORMA_INVOICE_SEARCH = "PROFORMA_INVOICE_SEARCH";
export const PROFORMA_INVOICE_SEARCH_SUCCESS =
  "PROFORMA_INVOICE_SEARCH_SUCCESS";
export const PROFORMA_INVOICE_SEARCH_FAILURE =
  "PROFORMA_INVOICE_SEARCH_FAILURE";
///proformainvoiceactivitylog/search
export const PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH =
  "PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH";
export const PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_SUCCESS =
  "PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_SUCCESS";
export const PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_FAILURE =
  "PROFORMA_INVOICE_ACTIVITY_LOG_SEARCH_FAILURE";
